import { useSuspenseQuery } from '@tanstack/react-query';

import { cacheKeys } from '../config';
import { disciplineClient } from '../client/disciplineClient';


export type Params = {
  id: number;
};

type Options = {

};

const defaultOptions: Partial<Options> = {
};

export const useDiscipline = (params: Params, options: Partial<Options> = defaultOptions) => {
  const { data: { data: discipline } = {}, ...rest } = useSuspenseQuery({
    queryKey: [cacheKeys.getDiscipline, params.id],
    queryFn: () => disciplineClient.getDiscipline(params),
  });

  return {
    ...rest,
    discipline,
  };
};
